import { render, staticRenderFns } from "./OrderManage.vue?vue&type=template&id=62bb1bc3&scoped=true"
import script from "./OrderManage.vue?vue&type=script&lang=js"
export * from "./OrderManage.vue?vue&type=script&lang=js"
import style0 from "./OrderManage.vue?vue&type=style&index=0&id=62bb1bc3&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62bb1bc3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62bb1bc3')) {
      api.createRecord('62bb1bc3', component.options)
    } else {
      api.reload('62bb1bc3', component.options)
    }
    module.hot.accept("./OrderManage.vue?vue&type=template&id=62bb1bc3&scoped=true", function () {
      api.rerender('62bb1bc3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/dining/cashier/OrderManage.vue"
export default component.exports